import { Link } from "react-router-dom";
import { Clock, Star } from "lucide-react";
import { getImageUrl } from "@/lib/api";
import { useCurrency } from "@/lib/CurrencyContext";

export const TourCard = ({ tour }) => {
  const imageUrl = getImageUrl(tour.images?.[0]);
  const { formatPrice } = useCurrency();
  const difficultyColor = {
    Easy: "text-canopy",
    Moderate: "text-sandy",
    Hard: "text-red-600",
  };

  return (
    <Link
      to={`/tours/${tour.tour_id}`}
      className="group block tour-card-hover"
      data-testid={`tour-card-${tour.tour_id}`}
    >
      <div className="overflow-hidden aspect-[4/5] mb-4">
        <img
          src={imageUrl}
          alt={tour.title}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <p className="uppercase text-xs tracking-[0.25em] text-sandy font-manrope mb-1.5">
        {tour.category}
      </p>
      <h3 className="font-cormorant text-xl text-midnight mb-2 leading-tight">
        {tour.title}
      </h3>
      <p className="font-manrope text-sm text-midnight/50 mb-3 line-clamp-2 leading-relaxed">
        {tour.description}
      </p>
      <div className="flex items-center justify-between">
        <span className="font-manrope text-sm text-midnight">
          From <strong className="font-semibold">{formatPrice(tour.price)}</strong>
        </span>
        <div className="flex items-center gap-3">
          {tour.avg_rating > 0 && (
            <span className="flex items-center gap-1 font-manrope text-xs text-sandy">
              <Star className="w-3 h-3 fill-sandy" /> {tour.avg_rating}
            </span>
          )}
          <span className="flex items-center gap-1 font-manrope text-xs text-midnight/40">
            <Clock className="w-3 h-3" /> {tour.duration}
          </span>
          <span className={`font-manrope text-xs uppercase tracking-wider ${difficultyColor[tour.difficulty] || ""}`}>
            {tour.difficulty}
          </span>
        </div>
      </div>
    </Link>
  );
};
